import CompanyAssignedTable from './companyAssignedTable.container';

export default CompanyAssignedTable;
